module.exports = __webpack_public_path__ + "static/img/4.7885c7f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/10/sp/4.png
// module id = sXKI
// module chunks = 0